import React, { useState } from "react"

import { interfaces } from "service/interfaces"
import DialogComponent from "Components/UI/Molecules/Modals/DialogComponent"
import useCustomSnackbar from "Components/UI/Atoms/SnackBar"
import CancelConfirmButtons from "Components/UI/Molecules/CancelConfirmButtons"

const Delete = (props) => {
  const { open, handleClose, handleRemoveClick, rowId, changeRender } =
    props

  const [loading, setLoading] = useState(false)

  const createDismissableSnackbar = useCustomSnackbar()

  const onSubmit = async () => {
  
    setLoading(true)
    await interfaces.configInterface
      .deleteRow(rowId)
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: "success",
        })
        handleRemoveClick()
        changeRender()
        handleClose()
      })
      .catch((error) =>
        createDismissableSnackbar(error.response.data.data, {
          variant: "error",
        })
      )
      .finally(handleClose)
    setLoading(false)
  }

  return (
    <div>
      <DialogComponent
        open={open}
        handleclose={handleClose}
        widthLarge="500px"
        title="¿Desea eliminar esta fila?"
        disableChildHeight
        disableBackdropClick
        disableEscapeKeyDown
        actions={
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <CancelConfirmButtons
              onClickCancel={handleClose}
              onClickSubmit={onSubmit}
              disabledCancel={loading}
              disabledSubmit={loading}
              isLoading={loading}
            />
          </div>
        }
      />
    </div>
  )
}

export default Delete
